const ORDER_CHANGE_QUANTITY = "ORDER_CHANGE_QUANTITY";
const ORDER_CHANGE_QUANTITY_SUCCESS = "ORDER_CHANGE_QUANTITY_SUCCESS";
const ORDER_CHANGE_QUANTITY_FAILURE = "ORDER_CHANGE_QUANTITY_FAILURE";
const CLEAR_ORDER_CHANGE_QUANTITY = "CLEAR_ORDER_CHANGE_QUANTITY";

const OrderChangeQuantitySymbols = {
  ORDER_CHANGE_QUANTITY_SUCCESS,
  ORDER_CHANGE_QUANTITY_FAILURE,
  ORDER_CHANGE_QUANTITY,
  CLEAR_ORDER_CHANGE_QUANTITY,
};
export default OrderChangeQuantitySymbols;
